module.exports = __webpack_public_path__ + "static/media/twitter-card.946883a5.JPG";